/*************************************************/
/* VIDEO                                         */
/*************************************************/

export function video() {
    let $video;

    const init = function () {
        $video = $(".video-item__player");

        // Video
        if ($video.length) {



            $video.click(function () {
                const that = $(this);
                const playerId = that.data("playerid");
                const videoId = that.data("videoid");
                const isYouku = that.data("isyouku") == "True";
                let playerName = `_${playerId}`;

                var iterations = 0;
                if (isYouku) {
                    var iframe = document.createElement('iframe');
                    iframe.src = "https://player.youku.com/embed/" + videoId;
                    iframe.style.width = "100%";
                    iframe.style.height = "100%";
                    iframe.frameBorder = 0;
                    iframe.addEventListener("load", e => {
                        that.addClass("video-item__player--playing");
                    });

                    const playerElement = document.getElementById(playerId);
                    if (playerElement) {
                        playerElement.appendChild(iframe);
                    }

                } else if (youtubeLoaded) {
                    playVideo();
                } else {
                    //Loading the youtube iframe api
                    var tag = document.createElement('script');
                    tag.src = "https://www.youtube.com/iframe_api";
                    var firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                    var loadViewTimer = setInterval(function () {
                        if (youtubeLoaded) {
                            clearInterval(loadViewTimer);
                            playVideo();
                        } else {
                            iterations++;
                        }
                        //Lets try for up to 10 seconds
                        if (iterations === 100) {
                            clearInterval(loadViewTimer);
                        }
                    }, 100);
                }

                function onPlayerReady(event) {
                    event.target.playVideo();
                    that.addClass("video-item__player--playing");
                }

                function onPlayerStateChange(event) {
                    if (event.data === YT.PlayerState.ENDED) {
                        playerName.destroy();
                        that.removeClass("video-item__player--playing");
                    }
                }

                function playVideo() {
                    playerName = new YT.Player(playerId, {
                        host: "https://www.youtube-nocookie.com",
                        height: "100%",
                        width: "100%",
                        videoId: videoId,
                        events: {
                            "onReady": onPlayerReady,
                            "onStateChange": onPlayerStateChange
                        },
                        playerVars: {
                            showinfo: 0,
                            rel: 0
                        }
                    });
                }
            });
        }
    };

    init();
}